import React, { Component } from 'react';
import { Form, Col, Row, Container } from 'react-bootstrap';

export default class FormInput extends Component {
  getInputField = (isReadonlyField) => {
    if (isReadonlyField) {
      return <Form.Control type="text" defaultValue={this.props.formData} readOnly />;
    } else {
      return <Form.Control type="text" defaultValue={this.props.formData} onChange={this.props.onChange} />;
    }
  };

  render() {
    return (
      <Container>
        <Form.Group controlId={this.props.fieldModel.name} key={this.props.index} as={Row}>
          <Form.Label id={this.props.fieldModel.name} column sm={2} className="dynamicFormLabel">
            {/* {camelCaseToTitleCase(this.props.fieldModel.name)} */}
            {this.props.fieldModel.name}
          </Form.Label>
          <Col sm={10}>{this.getInputField(this.props.readOnly)}</Col>
        </Form.Group>
      </Container>
    );
  }
}
